import { IconName, IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

interface EquipmentLabelProps {
    equipment: {
        name: string;
        category: string;
        equipid?: string;
        catalogNumber?: string;
        imgFileLocation?: string;
    };
    className?: string;
}

export const EquipmentLabel = ({ equipment, className }: EquipmentLabelProps) => {
    return (
        <div className={cn("equipment-label d-flex align-items-center gap-2", className)}>
            <div className="border rounded-1 flex-shrink-0 p-1 text-primary bg-primary bg-opacity-25">
                <div className="ratio ratio-1x1" style={{ width: "calc(var(--bs-body-font-size) * 1.65)" }}>
                    <FontAwesomeIcon icon={getCategoryIcon(equipment.imgFileLocation)} />
                </div>
            </div>
            <div className="d-flex flex-column">
                <span className="m-0 fw-bold text-break" id={`${equipment.equipid ?? equipment.catalogNumber}-name`}>
                    {equipment.name}
                </span>
                <div className="m-0 text-break fw-normal text-body opacity-70">
                    <span className="fw-bold">Category: </span>
                    {equipment.category}
                </div>
            </div>
        </div>
    );
};

const isValidIconName = (name?: string): name is IconName => true;

export function getCategoryIcon(imgFileLocation?: string): IconProp {
    const iconProps = imgFileLocation?.split(" ");
    if (iconProps) {
        const iconName = iconProps[iconProps?.length - 1]?.replace("fa-", "");
        return ["fal", isValidIconName(iconName) ? iconName : "cube"];
    }
    return ["fal", "cube"];
}
